import { EtrackerConfiguration } from 'graphql/types'

export function hasStatisticsConsent(): boolean {
    return typeof Cookiebot !== 'undefined' && Cookiebot.consent.statistics
}

export function isEtrackerConfig(config?: EtrackerConfiguration | null): config is EtrackerConfiguration {
    return Boolean(config?.enabled && config.secureCode && config.domain)
}

function getEtracker(): EtrackerInstance | undefined {
    return window._etracker
}

let consentListenerRegistered = false
let latestEtrackerConfig: EtrackerConfiguration | null = null

export function initEtrackerConsentHandling(config: EtrackerConfiguration): void {
    latestEtrackerConfig = config

    if (!consentListenerRegistered) {
        consentListenerRegistered = true
        window._etrackerOnReady = typeof window._etrackerOnReady === 'undefined' ? [] : window._etrackerOnReady

        window.addEventListener(
            'CookiebotOnConsentReady',
            () => {
                if (latestEtrackerConfig) {
                    applyEtrackerCookieConsent(latestEtrackerConfig)
                }
            },
            false,
        )
    }

    applyEtrackerCookieConsent(config)
}

function loadEtrackerScript(secureCode: string): void {
    if (document.getElementById('_etLoader')) {
        return
    }

    const loader = document.createElement('script')
    loader.id = '_etLoader'
    loader.type = 'text/javascript'
    loader.charset = 'UTF-8'
    loader.setAttribute('data-cookieconsent', 'statistics')
    loader.setAttribute('data-block-cookies', 'true')
    loader.setAttribute('data-page-changed-detection', 'hash')
    loader.setAttribute('data-secure-code', secureCode)
    loader.src = 'https://code.etracker.com/code/e.js'
    loader.async = true
    document.head.appendChild(loader)

    if (typeof Cookiebot !== 'undefined' && typeof Cookiebot.runScripts === 'function') {
        Cookiebot.runScripts()
    }
}

function applyEtrackerCookieConsent(config: EtrackerConfiguration): void {
    if (!hasStatisticsConsent()) {
        if (getEtracker()) {
            window._etrackerOnReady?.push(function () {
                getEtracker()?.disableCookies(config.domain)
            })
        }
        return
    }

    loadEtrackerScript(config.secureCode)
    window._etrackerOnReady?.push(function () {
        getEtracker()?.enableCookies(config.domain)
    })
}

export function trackVzfOrderNumber(secureCode: string, vzfID: string): void {
    if (getEtracker() && vzfID) {
        window.et_eC_Wrapper?.({ et_et: secureCode, et_tonr: vzfID })
    }
}

export function trackOrderConversion(secureCode: string, orderNumber: string, orderValue: number): void {
    if (getEtracker() && orderNumber) {
        window.et_eC_Wrapper?.({
            et_et: secureCode,
            et_tonr: orderNumber,
            et_tval: orderValue,
            et_tsale: 1,
        })
    }
}
